import React from 'react';
import BriefContactStatusModalMobile from './BriefContactStatusModalMobile';
import BriefContactStatusModalDesktop from './BriefContactStatusModalDesktop';

type Props = {
  contactStatus: 'success' | 'error' | null;
  isMobileView: boolean;
  clearStatus: () => void;
};

const BriefContactStatusModal = ({
  contactStatus,
  isMobileView,
  clearStatus,
}: Props) => {
  const navigateToBriefAndReload = () => {
    history.replaceState(history.state, '', '#brief');
    window.location.reload();
  };

  if (!contactStatus) return null;

  return isMobileView ? (
    <BriefContactStatusModalMobile
      contactStatus={contactStatus}
      clearStatus={clearStatus}
      reloadAndReopen={navigateToBriefAndReload}
    />
  ) : (
    <BriefContactStatusModalDesktop
      contactStatus={contactStatus}
      clearStatus={clearStatus}
      reloadAndReopen={navigateToBriefAndReload}
    />
  );
};

export default BriefContactStatusModal;
